<template>
  <CBox mt="10vw">
    <CHeading class="heading" textAlign="center" fontSize="2.5vw">
      Technical Skills
    </CHeading>
    <CBox
      class="skillContainer"
      d="flex"
      justifyContent="space-evenly"
      flexDirection="row"
      mt="2.5vw"
    >
      <Card
        class="card"
        width="20vw"
        height="28vw"
        borderRadius="1vw"
        heading="Languages"
        :options="languages"
      />
      <Card
        class="card"
        width="20vw"
        height="28vw"
        borderRadius="1vw"
        heading="Frameworks"
        :options="frameworksAndLibrary"
      />
      <Card
        class="card"
        width="20vw"
        height="28vw"
        borderRadius="1vw"
        heading="Databases"
        :options="databases"
      />
      <Card
        class="card"
        width="20vw"
        height="28vw"
        borderRadius="1vw"
        :options="familiarWith"
        heading="Familiar With"
      />
    </CBox>
  </CBox>
</template>

<script>
import { CBox, CHeading } from "@chakra-ui/vue";
import Card from "./Card.vue";

export default {
  name: "Skills",
  data() {
    return {
      languages: ["HTML", "CSS", "Java", "JavaScript", "SQL"],
      frameworksAndLibrary: [
        "Vue.js",
        "ReactJS",
        "NodeJS",
        "Android",
        "Spring",
      ],
      databases: ["MySQL", "SQLite", "MongoDB", "Firebase"],
      familiarWith: ["Git & GitHub", "C++", "Python"],
    };
  },
  components: {
    CBox,
    Card,
    CHeading,
  },
};
</script>

<style>
@media screen and (max-width: 480px) {
  .heading {
    margin-top: 15vw;
    font-size: 4vw;
    text-shadow: 0vw 0vw 5vw #8d4e85;
  }
  .skillContainer {
    flex-direction: column;
    margin-top: 7.5vw;
    gap: 5vw;
  }
}

.heading {
  transition: all 0.15s ease-in-out;
}

.heading:hover {
  transform: scale(1.1);
  text-shadow: 0vw 0vw 3vw #8d4e85;
}

.card {
  transition: transform 0.4s ease-in-out;
}

.card:hover {
  transform: scale(1.05);
}
</style>
